<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text" style="margin-left: 12px">
        <span> Интернет приемная </span>
      </div>
      <v-btn
        @click="goToPage"
        style="width: auto !important"
        class="button-action-blue"
      >
        Настройки раздела
      </v-btn>
    </div>
    <div class="main-container-info-box">
      <div class="container-block">
        <v-tabs color="var(--app-dark-blue-1)" v-model="currentTab">
          <v-tab v-for="(item, index) in tabs" :key="index"
            >{{ item.name }}
            <div class="tab-marker" v-if="item.hasUpdate"></div>
          </v-tab>
          <v-tab-item v-for="(item, index) in tabs" :key="index">
            <v-data-table
              :headers="computeHeaders"
              :items="displayedList"
              fixed-header
              :loading="loading"
              item-key="id"
              :key="tableUpKeys[item.value]"
              class="elevation-0 rounded-0 container-table"
              :disablePagination="currentTab == 3 || currentTab == 4"
              :footer-props="
                currentOptionTable
                  ? {
                      itemsPerPageOptions: [10, 25, 50],
                      'items-per-page-text': '',
                    }
                  : {}
              "
              :items-per-page="currentOptionTable?.itemsPerPage"
              :page="currentOptionTable?.page"
              :server-items-length="currentOptionTable?.serverItemsLength"
              @pagination="tableChange"
              :hide-default-footer="currentTab == 3 || currentTab == 4"
            >
              <template v-slot:[`body`]="{ items, headers }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item.id"
                    @click="openQuestionEditing(item, currentTab)"
                    style="cursor: pointer"
                  >
                    <td
                      v-for="header in headers"
                      :key="header.value"
                      :style="`width: ${header.width || 'auto'}`"
                    >
                      <div v-if="header.value == 'dateCreated'">
                        {{ item[header.value] | moment(" DD.MM.YYYY ") }}
                      </div>

                      <div v-else-if="header.value == 'type'">
                        {{ getType(item[header.value]) }}
                      </div>
                      <div v-else-if="header.value == 'answerCandidate'">
                        {{
                          item[header.value]?.user.fullName
                            ? item[header.value].user.fullName
                            : "Не указано"
                        }}
                      </div>
                      <div v-else-if="header.value == 'commentAnswer'">
                        <div class="answer">
                          {{ item[header.value]?.[header.subValue] }}
                        </div>
                      </div>
                      <div v-else-if="header.value == 'moderationStatus'">
                        <div
                          class="pending"
                          v-if="item[header.value] === 'pending'"
                        >
                          <div class="actions">
                            <v-btn
                              @click.stop="changeStatus(item, true, currentTab)"
                              style="width: auto !important"
                              class="button-accept-outlined-green"
                            >
                              Принять
                            </v-btn>
                            <v-btn
                              @click.stop="
                                changeStatus(item, false, currentTab)
                              "
                              style="width: auto !important"
                              class="button-cancel-outlined"
                            >
                              Отклонить
                            </v-btn>
                          </div>
                        </div>

                        <div
                          class="approve"
                          v-else-if="item[header.value] === 'approved'"
                        >
                          Одобрен
                        </div>
                        <div class="decline" v-else>Отклонен</div>
                      </div>
                      <div v-else-if="header.value == 'content'">
                        {{ item.question || item.answer || item.comment }}
                        <!-- Waiting for backend proper implementation -->
                      </div>
                      <div v-else-if="header.value == 'questionAuthor'">
                        {{ item[header.value]?.fullName || item.name }}
                      </div>

                      <div v-else>
                        {{ item[header.value] || "-" }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { io } from "socket.io-client";

export default {
  data: () => ({
    showInfo: false,
    settings: {},
    dialogImg: false,
    previewImage: null,
    imageWidth: 0,
    showInfoImg: false,
    showElection: false,
    currentTab: 0,
    tableUpKeys: {
      questions: 0,
      answers: 0,
      comments: 0,
    },
    optionTables: {
      questions: { page: 1, itemsPerPage: 10, serverItemsLength: -1 },
      answers: { page: 1, itemsPerPage: 10, serverItemsLength: -1 },
      comments: { page: 1, itemsPerPage: 10, serverItemsLength: -1 },
    },
    tabs: [
      { name: "Вопросы", hasUpdate: false, value: "questions" },
      { name: "Ответы", hasUpdate: false, value: "answers" },
      { name: "Комментарии", hasUpdate: false, value: "comments" },
      { name: "Одобренные", hasUpdate: false, value: "approved" },
      { name: "Отклоненные", hasUpdate: false, value: "declined" },
    ],

    tableHeaders: {
      questions: [
        {
          text: "Автор",
          sortable: false,
          value: "questionAuthor",
          width: "15%",
        },
        { text: "Вопрос", sortable: false, value: "question" },
        {
          text: "Дата создания",
          sortable: false,
          value: "dateCreated",
          width: "15%",
        },
        { text: "", sortable: false, value: "moderationStatus", width: "20%" },
      ],
      answers: [
        {
          text: "Автор",
          sortable: false,
          value: "answerCandidate",
          width: "15%",
        },
        { text: "Ответ", sortable: false, value: "answer" },
        {
          text: "Дата создания",
          sortable: false,
          value: "dateCreated",
          width: "12%",
        },
        { text: "", sortable: false, value: "moderationStatus" },
      ],
      comments: [
        {
          text: "Вопрос",
          sortable: false,
          value: "question",
          width: "20%",
        },
        {
          text: "Ответ",
          sortable: false,
          value: "commentAnswer",
          subValue: "answer",
          width: "20%",
        },
        { text: "Комментарий", sortable: false, value: "data", width: "20%" },
        {
          text: "Дата создания",
          sortable: false,
          value: "dateCreated",
          width: "12%",
        },
        { text: "", sortable: false, value: "moderationStatus", width: "10%" },
      ],
      approved: [
        { text: "Вид", sortable: false, value: "type" },
        { text: "Содержание", sortable: false, value: "content", width: "60%" },
        { text: "Дата создания", sortable: false, value: "dateCreated" },
      ],
      rejected: [
        { text: "Вид", sortable: false, value: "type" },
        { text: "Содержание", sortable: false, value: "content", width: "60%" },
        { text: "Дата создания", sortable: false, value: "dateCreated" },
      ],
    },

    selectorMap: {
      0: "candidates-questions",
      1: "candidates-answers",
      2: "candidates-answer-comments",
      3: "approved",
      4: "rejected",
    },

    socketSelectorMap: {
      0: "questions",
      1: "answers",
      2: "comments",
    },

    questionsBuffer: [],
    answersBuffer: [],
    commentsBuffer: [],
    displayedList: [],
    loading: false,

    socket: null,
  }),
  computed: {
    computeHeaders() {
      switch (this.currentTab) {
        case 0:
          return this.tableHeaders.questions;
        case 1:
          return this.tableHeaders.answers;
        case 2:
          return this.tableHeaders.comments;
        case 3:
          return this.tableHeaders.approved;
        case 4:
          return this.tableHeaders.rejected;
        default:
          return this.tableHeaders.questions;
      }
    },
    currentOptionTable() {
      const key = this.tabs[this.currentTab].value;
      if (key === "approved" || key === "declined") return null;
      return this.optionTables[key];
    },
  },
  methods: {
    showInApp() {
      const sendObject = {
        showElection: this.settings.showElection,
        icon: this.settings.icon,
        iconMobile: this.settings.iconMobile,
        iconTablet: this.settings.iconTablet,
      };
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-blocks/election-settings",
          sendObject,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.$store.commit("errorSet", {
            key: true,
            type: "success",
            text: "Настройки сохранены",
          });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    goToPage() {
      this.$emit("goToPage", "SettingsReception");
    },

    getType(item) {
      if (item === "question") {
        return "Вопрос";
      } else if (item === "answer") {
        return "Ответ";
      } else if (item === "comment") {
        return "Комментарий";
      } else {
        return "Ответ/комментарий";
      }
    },

    getName() {
      //name
    },

    handleTabMarker({ tab }) {
      const index = this.tabs.findIndex((item) => item.value === tab);
      if (index !== -1) {
        this.tabs[index].hasUpdate = true;
      }
    },

    openSocket() {
      const token = this.$store.getters.socketAdminKey;
      const url = this.$store.getters.socketUrlInternetReception;

      this.socket = io(url, {
        transports: ["websocket", "polling"],
        auth: {
          token,
          role: "admin",
        },
      });

      this.socket.on("update:questions", (data) => {
        const questionIndex = this.questionsBuffer.findIndex(
          (question) => question.id === data.id
        );
        if (questionIndex !== -1) {
          this.questionsBuffer[questionIndex] = data;
        } else {
          this.questionsBuffer.unshift(data);
        }
        if (this.currentTab === 0) {
          this.displayedList = this.questionsBuffer;
        }
        this.tableUpKeys["questions"]++;
      });
      this.socket.on("update:answers", (data) => {
        const answerIndex = this.answersBuffer.findIndex(
          (answer) => answer.id === data.answer.id
        );
        if (answerIndex !== -1) {
          this.answersBuffer[answerIndex] = data.answer;
        } else {
          this.answersBuffer.unshift(data.answer);
        }
        if (this.currentTab === 1) {
          this.displayedList = this.answersBuffer;
        }
        this.tableUpKeys["answers"]++;
      });
      this.socket.on("update:comments", (data) => {
        const commentIndex = this.commentsBuffer.findIndex(
          (comment) => comment.id === data.comment.id
        );
        if (commentIndex !== -1) {
          this.commentsBuffer[commentIndex] = data.comment;
        } else {
          this.commentsBuffer.unshift(data.comment);
        }
        this.commentsBuffer.forEach(
          (item) =>
            (item.question = item.commentAnswer?.answerQuestion?.question || "")
        );
        if (this.currentTab === 2) {
          this.displayedList = this.commentsBuffer;
        }
        this.tableUpKeys["comments"]++;
      });
      this.socket.on("tab-marker", this.handleTabMarker);

      this.socket.emit("subscribe-to-tab", {
        tab: "questions",
      });
      this.socket.on("delete:answers", (data) => {
        data.answerIds.forEach((id) => {
          const answerIndex = this.answersBuffer.findIndex(
            (answer) => answer.id === id
          );
          if (answerIndex !== -1) {
            this.answersBuffer.splice(answerIndex, 1);
          }
        });
        this.tableUpKeys["answers"]++;
      });
      this.socket.on("delete:comments", (data) => {
        data.commentIds.forEach((id) => {
          const commentIndex = this.commentsBuffer.findIndex(
            (comment) => comment.id === id
          );
          if (commentIndex !== -1) {
            this.commentsBuffer.splice(commentIndex, 1);
          }
        });
        this.tableUpKeys["comments"]++;
      });
    },

    openQuestionEditing(item, tabIndex) {
      const mapPage = {
        0: "EditQuestion",
        1: "EditAnswer",
        2: "EditComment",
      };

      if (tabIndex === 1) this.$route.query.questionId = item.questionId;
      if (tabIndex === 2)
        this.$route.query.questionId = item.commentAnswer.questionId;
      this.$route.query.id = item.id;
      this.$emit("goToPage", mapPage[tabIndex]);
    },

    async changeStatus(item, approve, tabIndex) {
      const statusMap = {
        0: "Статус вопроса изменен",
        1: "Статус ответа изменен",
        2: "Статус комментария изменен",
      };
      const body = {
        questionId:
          tabIndex === 0
            ? item.id
            : item.questionId
            ? item.questionId
            : item.commentAnswer.questionId,
        moderationStatus: approve ? "approved" : "declined",
        id: tabIndex !== 0 ? item.id : undefined,
      };
      this.$axios
        .put(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-${this.selectorMap[tabIndex]}/moderation`,
          body,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.$store.commit("errorSet", {
            key: true,
            type: "success",
            text: statusMap[tabIndex],
          });
        })

        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    tableChange(pagination) {
      const key = this.tabs[this.currentTab].value;
      if (key === "approved" || key === "declined") return;
      const tableOpts = this.optionTables[key];
      if (
        tableOpts.page === pagination.page &&
        tableOpts.itemsPerPage === pagination.itemsPerPage
      ) {
        return;
      }
      tableOpts.page = pagination.page;
      tableOpts.itemsPerPage = pagination.itemsPerPage;
      switch (key) {
        case "questions":
          this.getQuestionsList();
          break;
        case "answers":
          this.getAnswersList();
          break;
        case "comments":
          this.getCommentsList();
          break;
        default:
          break;
      }
    },
    async getQuestionsList() {
      return await this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-candidates-questions/list-ap`,
          {
            params: {
              page: this.optionTables.questions.page,
              limit: this.optionTables.questions.itemsPerPage,
            },
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.tabs[0].hasUpdate = false;
          this.questionsBuffer = res.data.data;
          this.optionTables.questions = {
            page: res.data.page,
            itemsPerPage: res.data.limit,
            serverItemsLength: res.data.total,
          };
          if (this.currentTab === 0) {
            this.displayedList = this.questionsBuffer;
          }
          return this.answersBuffer;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    async getAnswersList() {
      return await this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-candidates-answers/list`,
          {
            params: {
              page: this.optionTables.answers.page,
              limit: this.optionTables.answers.itemsPerPage,
            },
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.tabs[1].hasUpdate = false;
          this.answersBuffer = res.data.data;
          this.optionTables.answers = {
            page: res.data.page,
            itemsPerPage: res.data.limit,
            serverItemsLength: res.data.total,
          };
          if (this.currentTab === 1) {
            this.displayedList = this.answersBuffer;
          }
          return this.answersBuffer;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    async getCommentsList() {
      return await this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-candidates-answer-comments/list`,
          {
            params: {
              page: this.optionTables.comments.page,
              limit: this.optionTables.comments.itemsPerPage,
            },
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.tabs[2].hasUpdate = false;
          this.commentsBuffer = res.data.data;
          this.optionTables.comments = {
            page: res.data.page,
            itemsPerPage: res.data.limit,
            serverItemsLength: res.data.total,
          };
          this.commentsBuffer.forEach(
            (item) =>
              (item.question =
                item.commentAnswer?.answerQuestion?.question || "")
          );
          if (this.currentTab === 2) {
            this.displayedList = this.commentsBuffer;
          }
          return this.commentsBuffer;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    async getTableData() {
      await Promise.all([
        this.getQuestionsList(),
        this.getAnswersList(),
        this.getCommentsList(),
      ]);
    },
  },
  async created() {
    await this.getTableData();
    this.openSocket();
  },
  onUnmounted() {
    this.socket.disconnect();
  },
  watch: {
    currentTab() {
      this.socket.emit("subscribe-to-tab", {
        tab: this.socketSelectorMap[this.currentTab],
      });
      this.loading = true;
      const filterApproved = (arr) =>
        arr.filter((item) => item.moderationStatus === "approved");
      const filterDeclined = (arr) =>
        arr.filter((item) => item.moderationStatus === "declined");
      (async () => {
        switch (this.currentTab) {
          case 0:
            if (this.tabs[0].hasUpdate) {
              Promise.resolve(this.getQuestionsList());
            } else {
              this.displayedList = this.questionsBuffer;
            }
            this.loading = false;
            break;
          case 1:
            if (this.tabs[1].hasUpdate) {
              await Promise.resolve(this.getAnswersList());
            } else {
              this.displayedList = this.answersBuffer;
            }
            this.loading = false;
            break;
          case 2:
            if (this.tabs[2].hasUpdate) {
              await Promise.resolve(this.getCommentsList());
            } else {
              this.displayedList = this.commentsBuffer;
            }
            this.loading = false;
            break;
          case 3:
            this.displayedList = [
              ...filterApproved(this.questionsBuffer),
              ...filterApproved(this.answersBuffer),
              ...filterApproved(this.commentsBuffer),
            ];
            this.loading = false;
            break;
          case 4:
            this.displayedList = [
              ...filterDeclined(this.questionsBuffer),
              ...filterDeclined(this.answersBuffer),
              ...filterDeclined(this.commentsBuffer),
            ];
            this.loading = false;
            break;
          default:
            this.displayedList = this.questionsBuffer;
        }
      })();
    },
    deep: true,
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  overflow-wrap: anywhere;
  .main-container-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px 24px 20px 24px;

    .main-container-title-box-text {
      display: flex;
      align-items: center;

      span {
        font-size: 28px;
        font-weight: 400;
        margin-right: 20px;
      }
    }
  }

  .main-container-info-box {
    padding: 0 24px;
    .table-title {
      font-size: 24px;
      font-weight: 600;
      margin: 0 24px;
    }

    .tab-marker {
      position: absolute;
      right: 10px;
      top: 16px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: var(--app-red-1);
    }

    .pending {
      .actions {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
      }
    }
    .approve {
      color: var(--app-green-1);
      font-weight: 400;
      font-size: 14px;
    }
    .decline {
      color: var(--app-red-1);
      font-weight: 400;
      font-size: 14px;
    }

    .info-block {
      width: 50%;
      margin-bottom: 50px;

      .info-block-title {
        font-size: 24px;
        font-weight: 600;
      }

      .info-block-text {
        font-size: 18px;
        font-weight: 400;
      }
    }

    .table-img {
      cursor: pointer;
      height: 38px;
      object-fit: contain;
    }
  }
}

.table-title {
  font-size: 24px;
  font-weight: 600;
}
</style>
